// Local translations
export const T = {
  en_GB: {
    heading: "IMAP Account",
    intro:
      "Read-only mailbox access for the AI assistant. Stored encrypted, only one account per user.",
    displayName: "Display name",
    emailAddress: "Email address",
    imapHost: "IMAP host (e.g. imap.gmail.com)",
    port: "Port",
    password: "Password",
    passwordKeep: "Password (leave blank to keep current)",
    passwordRequired: "Password is required",
    save: "Save",
    add: "Add",
    cancel: "Cancel",
    saveFailed: "Failed to save",
    testConnection: "Test connection",
    edit: "Edit",
    delete: "Delete",
    noTls: "no TLS",
    connected: (count: string) => `Connected — ${count} messages in INBOX`,
    failed: "Failed",
    error: "Error",
    deleteFailed: "Delete failed",
    confirmDelete: (email: string) => `Delete IMAP account ${email}?`,
  },
  nb_NO: {
    heading: "IMAP-konto",
    intro:
      "Skrivebeskyttet tilgang til postkassen for AI-assistenten. Lagres kryptert, kun én konto per bruker.",
    displayName: "Visningsnavn",
    emailAddress: "E-postadresse",
    imapHost: "IMAP-vert (f.eks. imap.gmail.com)",
    port: "Port",
    password: "Passord",
    passwordKeep: "Passord (la stå tomt for å beholde nåværende)",
    passwordRequired: "Passord er påkrevd",
    save: "Lagre",
    add: "Legg til",
    cancel: "Avbryt",
    saveFailed: "Kunne ikke lagre",
    testConnection: "Test tilkobling",
    edit: "Rediger",
    delete: "Slett",
    noTls: "uten TLS",
    connected: (count: string) => `Tilkoblet — ${count} meldinger i INNBOKS`,
    failed: "Mislyktes",
    error: "Feil",
    deleteFailed: "Sletting mislyktes",
    confirmDelete: (email: string) => `Slette IMAP-kontoen ${email}?`,
  },
} as const;
